export default __webpack_public_path__ + "static/media/logo.14e807b1.svg";